import React from 'react';
import { PageTitle, SectionTitle } from '../../components/PageTitle/PageTitle.styled';
import { GreenroadStyled } from './Greenroad.styled';
import Container from '../../components/Container/Container';
import { CardText } from '../../components/Card/Card.styled';
import Card from '../../components/Card/Card';
import FormRequest from '../../components/Form/FormRequest';
import CompanyCard from '../../components/CompanyCard/CompanyCard';
import companyLogo from '../../assets/images/logo/greenroad.svg';
import companyImage from '../../assets/images/companies/greenroad.png';
// @ts-ignore
import SEO from '@americanexpress/react-seo';

function Greenroad(): JSX.Element {
  return (
    <GreenroadStyled>
      <SEO
        title="RGRauto | GreenRoad"
      />
      <Container>
        <PageTitle>GreenRoad</PageTitle>
        <CompanyCard
          name="GreenRoad"
          logo={companyLogo}
          image={companyImage}
          buttons={[
            {
              title: 'About Drive™',
              url: '/greenroad/drive',
            },
          ]}
        >
          <p>
            GreenRoad
          </p>
          <p>
            Drive™
          </p>
        </CompanyCard>
        <Card>
          <SectionTitle>Request a demo</SectionTitle>
          <CardText>
            To request a demo, please complete the form below <br />
            and we will contact you as soon as possible
          </CardText>
          <FormRequest />
        </Card>
      </Container>
    </GreenroadStyled>
  );
}

export default Greenroad;
